import ChatInput from './ChatInput';
import { CaretLeft, PencilSimple, XCircle } from '@phosphor-icons/react';
import MessagesWrapper from './MessagesWrapper';
import ChatHistory from './ChatHistory';
import useChatAI from '../../../../hooks/useChatAI';
import { Conversation } from '../../../../@types/IA.type';
import { ChatAgent } from '../../../../@types/EnumsAI.enum';

const ChatComplete = ({
	handleClose,
	chatName,
	containerStyles,
	showLastChat = false,
	initialMessage,
	agentName,
	canClose = false,
}: {
	handleClose: () => void;
	chatName?: string;
	containerStyles?: string;
	showLastChat?: boolean;
	initialMessage: Conversation;
	initialOptions?: { label: string; message: string }[];
	agentName?: ChatAgent;
	canClose?: boolean;
}) => {
	const {
		currentThread,
		chatHistory,
		handleNewChat,
		getMessageHistory,
		showMessages,
		setShowMessages,
		messagesRef,
		isLoading,
		setCurrentThread,
		userMessage,
		setUserMessage,
		handleSubmit,
		messageRecommendations,
	} = useChatAI({
		showLastChat,
		initialMessage,
		agentName,
		canClose,
	});

	const handleOptionClick = async (message: string) => {
		handleSubmit(message);
	};

	const options = (
		<div className='flex items-center justify-between gap-2 p-2'>
			<ChatHistory
				chatHistory={chatHistory}
				setCurrentThread={setCurrentThread}
				getMessageHistory={getMessageHistory}
				currentThread={currentThread}
			/>
			<div className='flex items-center gap-2'>
				<button
					onClick={handleNewChat}
					className='whitespace-nowrap flex items-center gap-1 hover:text-h-neutral-20 text-h-neutral-40 text-xs w-fit bg-h-neutral-94 hover:bg-h-primary-90/50 pr-2 rounded-3xl p-1'
				>
					<PencilSimple
						size={18}
						weight='bold'
					/>{' '}
					Nuevo
				</button>
				{canClose && (
					<button onClick={() => setShowMessages(false)}>
						<XCircle
							size={24}
							weight='fill'
							className='text-h-neutral-60'
						/>
					</button>
				)}
			</div>
		</div>
	);
	return (
		<div
			className={`bg-white fade-in-scale md:rounded-3xl border-2 border-h-neutral-94 shadow-lg md:p-0.5 flex flex-col flex-1 h-full overflow-hidden ${showMessages ? containerStyles : ''}`}
		>
			{showMessages && (
				<div className={`flex flex-col flex-1 overflow-hidden`}>
					<div className='border-b border-h-neutral-90 md:hidden flex items-center justify-between'>
						{!canClose ? (
							<button
								onClick={handleClose}
								className='p-1 flex items-center gap-1 w-20 text-sm'
							>
								<CaretLeft
									size={18}
									weight='bold'
									className=''
								/>
								Volver
							</button>
						) : (
							<div />
						)}
						{options}
					</div>
					<div className='hidden md:block'>{options}</div>
					{/* ========== MESSAGES ========== */}
					<MessagesWrapper
						messagesRef={messagesRef}
						currentConversation={currentThread}
						isLoading={isLoading}
						containerStyles='h-full'
						chatName={chatName}
					/>

					{!userMessage &&
						currentThread?.thread.length < 2 &&
						!isLoading.history && (
							<div className='flex flex-col gap-2 p-2'>
								{messageRecommendations.map((option, index) => (
									<button
										key={option.label}
										onClick={() => handleOptionClick(option.message)}
										className='bg-h-primary-90/50 border border-h-primary-90 text-dark w-fit text-sm px-3 py-1.5 rounded-full fade-in-scale hover:bg-h-primary-90 transition-all duration-100'
										style={{
											animation: 'fadeInScale 0.3s ease forwards',
											animationDelay: `${500 + index * 100}ms`,
											opacity: 0,
										}}
									>
										{option.label}
									</button>
								))}
							</div>
						)}
				</div>
			)}

			{/* ========== INPUT ========== */}
			<ChatInput
				showMessages={showMessages}
				setShowMessages={setShowMessages}
				isLoading={isLoading}
				setCurrentThread={setCurrentThread}
				getMessageHistory={getMessageHistory}
				chatHistory={chatHistory}
				userMessage={userMessage}
				setUserMessage={setUserMessage}
				handleSubmit={handleSubmit}
			/>
			<div className='bg-h-neutral-94 h-2 block  ' />
			<div className='bg-white block text-[10px] leading-3 opacity-60 text-center p-2'>
				Las respuestas son generadas por inteligencia artificial y pueden
				contener errores.
			</div>
		</div>
	);
};

export default ChatComplete;
